import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IsearchJefeHogar, CustomTableComponent, ICustomTable, DataColumnType, ISettings, ButtonColumnType, CustomTitle } from 'lib-base';
import { SisbenConsultaService } from '../../../services/sisben/sisben-consulta.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { ISisbenResultadoConsulta } from '../../../shared/interfaces/sisben/sisben';

@Component({
  selector: 'app-consulta-sisben-resultados',
  standalone: true,
  imports: [CustomTableComponent, CustomTitle, TranslatePipe],
  template: `
  <div class="col-12 flex flex-column px-6 pb-6">
    <div>
      <CustomTitle [title]="'common.resultadoRespuesta' | translate"
          styleClass="font-principal app-title-page-color font-medium font-18 text-uppercase mt-2"/>
    </div>
    <custom-table [config]="configTable"/>
  </div>
  `
})
export class ConsultaSisbenResultadosComponent implements OnInit, AfterViewInit {

  @Input() props: IsearchJefeHogar | undefined;

  _translations: any = {};
  configTable!: ICustomTable;
  private _resultados: ISisbenResultadoConsulta[] = [];
  @ViewChild(CustomTableComponent) customTableComponent!: CustomTableComponent;

  constructor(
    private readonly _scs: SisbenConsultaService,
    private readonly _t: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.getTranslations()
      .then(() => this.getConfigTable());
  }

  ngAfterViewInit(): void {
    if (this.customTableComponent && !this._resultados.length) {
      setTimeout(() => {
        this.customTableComponent.data = [];
      }, 300);
    }
  }

  private async getTranslations(): Promise<void> {
    this._translations = await firstValueFrom(forkJoin({
      aceptar: this._t.get('form.button.aceptar'),
      cargando: this._t.get('msg.cargando'),
    }));
  }

  private getConfigTable(): void {
    this.configTable = {
      columns: [
        {
          field: 'tipoIdentificacion',
          header: this._t.instant('common.tipoIdentificacion'),
          class: 'font-13 py-3',
          width: '20em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'identificacion',
          header: this._t.instant('common.identificacion'),
          class: 'font-13 py-3',
          width: '20em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'nombreCompleto',
          header: this._t.instant('common.nombreCompleto'),
          class: 'font-13 py-3',
          width: '25em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'search',
          header: '',
          icon: 'pi pi-search',
          width: '0rem',
          class: 'pt-2 pb-2 pr-1 p-button-outlined',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: any, data: ISisbenResultadoConsulta) => this.openProfile(data)
        }
      ],
      settings: {
        table: {
          rows: 8,
          lazy: true
        }
      } as ISettings
    } as ICustomTable;
  }

  private openProfile(data: ISisbenResultadoConsulta): void {
    window.open(`#/sisben/perfil/${data.id}`, '_blank');
  }

  public setResultados(data: ISisbenResultadoConsulta[] | null): void {
    if (this.customTableComponent) {
      this._resultados = data ?? [];
      this.customTableComponent.data = data ?? [];
    }
  }

  clearData(): void {
    this.props = undefined;
    if (this.customTableComponent) {
      this.customTableComponent.data = [];
    }
    this._resultados = [];
  }
}

